// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 950 ? "mediapipe-bg-worker" : chunkId) + "." + {"249":"7d0f82dd","950":"5873cdab"}[chunkId] + ".chunk.js";
};